import React from 'react';
import { useCallback } from 'react';
import { useState, useEffect } from 'react';

const CountDown = ({ deadline }) => {
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [isDeadlineCrossed, setIsDeadlineCrossed] = useState(false);

    const getTime = useCallback(() => {
        const time = Date.parse(deadline) - Date.now();
        if (time > 0) {
            let days = Math.floor(time / (1000 * 60 * 60 * 24));
            if (days) {
                let hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + days * 24;
                setHours(hours);
            }
            setMinutes(Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)));
            setSeconds(Math.floor((time % (1000 * 60)) / 1000));
        } else setIsDeadlineCrossed(time < 0);
    }, [deadline]);

    useEffect(() => {
        const time = Date.parse(deadline) - Date.now();
        setIsDeadlineCrossed(time < 0);
    }, [deadline]);

    useEffect(() => {
        if (!isDeadlineCrossed) {
            const interval = setInterval(() => getTime(deadline), 1000);
            return () => clearInterval(interval);
        }
    }, [deadline, getTime, isDeadlineCrossed]);

    return (
        <div className='flex gap-2'>
            <Time num={hours} isDeadlineCrossed={isDeadlineCrossed} label='Hour' showColan />
            <Time num={minutes} isDeadlineCrossed={isDeadlineCrossed} label='Min' showColan />
            <Time num={seconds} isDeadlineCrossed={isDeadlineCrossed} label='Sec' />
        </div>
    );
};

export default CountDown;

const Time = (props) => {
    let { num, isDeadlineCrossed, label, showColan } = props;
    num = num > 0 ? num.toString() : '0';
    if (num.length === 1) num = `0${num}`;

    const boxClassName = `px-2 bg-scogobgsky py-1 text-white flex items-center justify-center rounded-lg ${isDeadlineCrossed ? ' bg-scogogray ' : ''}`;

    return (
        <>
            <div className='flex gap-2'>
                <div className='flex flex-col items-center'>
                    <div className='flex gap-2'>
                        <span className={boxClassName}>{num[0]}</span> <span className={boxClassName}>{num[1]}</span>
                    </div>
                    <p className='text-sm font-bold text-scogoprimary text-center'>{label}</p>
                </div>
                {showColan && <span className='font-bold text-2xl text-scogoprimary'>:</span>}
            </div>
        </>
    );
};
